import { createSlice } from '@reduxjs/toolkit';
import initialState from './Developer.state';
import reducers from './Developer.reducers';

export default createSlice({
	name: 'Developer',
	initialState,
	reducers,
});